module.exports = __webpack_public_path__ + "static/dl2-stay-human_tablet2-6ccd805203958e71363753d9a145d5f1.png";